import { NgModule } from '@angular/core';
import { IntentNumberAbbreviatorPipe } from './intent-number-abbreviator.pipe';

@NgModule({
    declarations: [IntentNumberAbbreviatorPipe],
    exports: [IntentNumberAbbreviatorPipe],
})
export class IntentNumberAbbreviatorPipeModule {}
